import { gql, useQuery } from '@apollo/react-hooks';
import { type PublicationData, type Publication } from './types';
import {
  PublicationStatusOptions,
  PublicationTypesOptions,
  ApplicantRoleOptions,
} from '../../../../../Application/components';
import dayjs from 'dayjs';

export const useGetPublicationData = (id: string): PublicationData => {
  const { data, loading, error } = useQuery(
    gql`
      query ($id: ID!) {
        publication(id: $id) {
          publicationStatus
          applicantRole
          specificRole

          publicationDate
          publicationType
          publicationAuthors
          publicationTitle
          publicationName
          publicationUrl
          citationInfo
          supportingDocuments {
            id
            link
            name
          }
        }
      }
    `,
    {
      variables: { id },
      skip: !id,
      fetchPolicy: 'network-only',
    },
  );

  const StatusOption = PublicationStatusOptions.find(
    option => option.value === data?.publication?.publicationStatus,
  );
  const StatusLabel = StatusOption?.label?.toString();

  const PublicationTypesOption = PublicationTypesOptions.find(
    option => option.value === data?.publication?.publicationType,
  );
  const PublicationTypesLabel = PublicationTypesOption?.label?.toString();

  const ApplicantRoleOption = ApplicantRoleOptions.find(
    option => option.value === data?.publication?.applicantRole,
  );
  const ApplicantRoleLabel = ApplicantRoleOption?.label?.toString();
  const publicationDate =
    dayjs(data?.publication?.publicationDate).format('DD/MM/YYYY') ?? ' - ';

  const publication: Publication = {
    publicationStatus: StatusLabel ?? ' - ',
    applicantRole: ApplicantRoleLabel ?? ' - ',
    specificRole: data?.publication?.specificRole ?? ' - ',
    publicationDate,
    publicationType: PublicationTypesLabel ?? ' - ',
    publicationAuthors: data?.publication?.publicationAuthors,
    publicationTitle: data?.publication?.publicationTitle,
    publicationName: data?.publication?.publicationName ?? ' - ',
    publicationUrl: data?.publication?.publicationUrl ?? ' - ',
    citationInfo: data?.publication?.citationInfo ?? ' - ',
    supportingDocuments: data?.publication?.supportingDocuments ?? [],
  };

  return { publication, loading, error };
};
